import type { NextPage } from "next"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { BusinessLoading } from "app/[business]/loading"
import { useViewerMemberQuery } from "interface/__generated__/react"

const BusinessPage: NextPage = () => {
  const router = useRouter()
  const businessLogin = router.query.business as string

  const { data: memberData, error: viewerMemberError, loading: memberLoading } = useViewerMemberQuery({
    variables: {
      businessLogin: businessLogin || "",
    },
    skip: !router.isReady || !businessLogin,
  })

  useEffect(() => {
    if (!router.isReady || memberLoading) return

    if (viewerMemberError) {
      // エラーの場合はホームページにリダイレクト
      // Business access error, redirecting to home
      router.replace("/")
      return
    }

    const member = memberData?.viewer?.member ?? null
    
    if (member) {
      // メンバーが存在する場合のみリダイレクト
      router.replace(`/${businessLogin}/member/shifts`)
    } else {
      // メンバーが存在しない場合はホームページにリダイレクト
      // No member found for business, redirecting to home
      router.replace("/")
    }
  }, [router, businessLogin, memberData, viewerMemberError, memberLoading])

  // ローディング表示
  return <BusinessLoading />
}

export default BusinessPage
